import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";
import { format } from "date-fns";


const addAgreement = (agreement, token) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/agreement/create", 
  {
    id: agreement.id,
    companyId: agreement.companyName,
    initialDate: format(new Date(agreement.initDate), "yyyy-MM-dd"),
    endDate: format(new Date(agreement.endDate), "yyyy-MM-dd")
  }
  , config);
};

const updateAgreement = (agreement, token) => {
  const config = configurationForToken(token);
  return apiClient.put("/admin/agreement/edit", 
  {
    id: agreement.id,
    companyId: agreement.companyName,
    initialDate: format(new Date(agreement.initDate), "yyyy-MM-dd"),
    endDate: format(new Date(agreement.endDate), "yyyy-MM-dd")
  }, config);
};

const deleteAgreement = (agreementId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/admin/agreement/delete", { data: {id: agreementId}, ...config });
};

const allAgreements = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/agreement/all", config);
};

export default {
  addAgreement,
  updateAgreement,
  deleteAgreement,
  allAgreements,
};



// WEBPACK FOOTER //
// ./src/Services/AgreementService.js